module.exports = __webpack_public_path__ + "img/iframe.33a5ac66.png";